export default {
  followInstructionsInEmail: 'Please follow the instructions in your email',
  resetPassword: 'Reset password',
  youAreLoggedIn: 'You are already logged in',
  goHome: 'Go Home',
  signOut: 'Sign out',
  password: 'Password',
  forgotMyPassword: 'Forgot my password',
  createAnAccount: 'Create an account',
  login: 'Log in',
  name: 'Name',
  lastName: 'Last name',
  createAccount: 'Create account',
  ifYouHaveAnAccount: 'If you have an account',
  yourPasswordHasBeenChanged: 'Your password has been changed',
  resetLinkExpired: 'The reset link expired, please start again',
  newPassword: 'New password',
  passwordRequirements: 'Your password must be at least 8 characters long',
  confirmPassword: 'Confirm password',
  emailVerficationCodeExpired: 'The verification code expired',
  weAreVerifyingYourEmail: 'We are verifying your email'
}
